import { RCCallout } from '@reverbdotcom/cadence/components';
import React from 'react';
import I18n from 'i18n-js';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { CheckCircleIcon } from '@reverbdotcom/cadence/icons/react';

interface ExternalProps {
  allStatementsPaid: boolean;
  statementFullyPaid: boolean;
}

function StatementPaymentSuccessBanner({
  allStatementsPaid,
  statementFullyPaid,
}: ExternalProps) {

  function getText(textType: string) {
    let text = textType;

    if (allStatementsPaid) {
      text += 'AllStatementsPaid';
    } else if (statementFullyPaid) {
      text += 'StatementFullyPaid';
    } else {
      text += 'StatementPartiallyPaid';
    }

    return `discovery.payStatement.paymentSuccessBanner.${text}`;
  }

  return (
    <div className="scaling-mb-4">
      <RCCallout
        title={I18n.t(getText('header'))}
        themeType="utility"
        variant="success-ultralight"
        icon={<CheckCircleIcon weight="fill" />}
        compact
      >
        <Translate
          tag="p"
          text={getText('message')}
        />
      </RCCallout>
    </div>
  );
}

export default StatementPaymentSuccessBanner;
